<div class="column content-container">
	<div class="content-container-header mat-h3" i18n="@@ConfirmationHeader">Confirmation</div>

	<mat-divider></mat-divider>

	<div class="content-container-body">
		@if (showLoading) {
			<div>
				<mat-spinner diameter="35" style="float: left"></mat-spinner>
				<h3 style="float: left; margin-top: 7px; margin-left: 1em" i18n="@@addDeviceGroup-loadingMessage">
					Loading...
				</h3>
			</div>
		}

		@if (showSuccess) {
			<div>
				@if (created) {
					<div data-automation-id="add-device-group-created-confirmation">
						<ng-container i18n="@@addDeviceGroup-devicesAddedConfirmationPrefix"
							>This is a confirmation that</ng-container
						><ng-container>&nbsp;</ng-container><b>{{ deviceGroupName }}</b
						><ng-container>&nbsp;</ng-container>
						<ng-container i18n="@@addDeviceGroup-hasBeenCreatedAnd">has been created and</ng-container
						><ng-container>&nbsp;</ng-container>
						<b
							>{{ deviceCount }}
							<ng-container [ngPlural]="deviceCount">
								<ng-template i18n="@@addDeviceGroup-deviceSingular" ngPluralCase="=1">device</ng-template>
								<ng-template i18n="@@addDeviceGroup-devicePlural" ngPluralCase="other">devices</ng-template>
							</ng-container>
						</b>
						<ng-container>&nbsp;</ng-container>
						<ng-container [ngPlural]="deviceCount">
							<ng-template i18n="@@addDeviceGroup-hasBeenAddedTo" ngPluralCase="=1">has been added to</ng-template>
							<ng-template i18n="@@addDeviceGroup-haveBeenAddedTo" ngPluralCase="other">have been added to</ng-template>
						</ng-container>
						<ng-container>&nbsp;</ng-container>
						<ng-container i18n="@@addDeviceGroup-theGroup">the group</ng-container>.
					</div>
				} @else {
					<div data-automation-id="add-device-group-devices-added-confirmation">
						<ng-container i18n="@@addDeviceGroup-devicesAddedConfirmationPrefix"
							>This is a confirmation that</ng-container
						><ng-container>&nbsp;</ng-container>
						<b
							>{{ deviceCount }}
							<ng-container [ngPlural]="deviceCount">
								<ng-template i18n="@@addDeviceGroup-deviceSingular" ngPluralCase="=1">device</ng-template>
								<ng-template i18n="@@addDeviceGroup-devicePlural" ngPluralCase="other">devices</ng-template>
							</ng-container>
						</b>
						<ng-container>&nbsp;</ng-container>
						<ng-container [ngPlural]="deviceCount">
							<ng-template i18n="@@addDeviceGroup-hasBeenAddedTo" ngPluralCase="=1">has been added to</ng-template>
							<ng-template i18n="@@addDeviceGroup-haveBeenAddedTo" ngPluralCase="other">have been added to</ng-template>
						</ng-container>
						<ng-container>&nbsp;</ng-container>
						<b>{{ deviceGroupName }}</b
						>.
					</div>
				}
			</div>
		}

		@if (showFailure) {
			<div i18n="@@addDeviceGroup-FailureMessage">
				<h3>
					Error creating device group <b>{{ deviceGroupName }}.</b>
				</h3>
			</div>
		}

		@if (showSuccess || showFailure) {
			<div>
				<div style="margin-top: 24px; margin-bottom: 24px">
					<mat-divider></mat-divider>
				</div>
				<div style="position: sticky; float: left; margin-top: 8px">
					<button
						mat-button
						class="primary-button"
						(click)="returnToGroups()"
						i18n="@returnToGroups"
						data-automation-id="return-to-groups-button"
					>
						Return to Groups
					</button>
					<button
						mat-button
						class="secondary-button"
						(click)="viewGroupDetails()"
						i18n="@@viewGroupDetails"
						data-automation-id="view-group-details-button"
					>
						View Group Details
					</button>
				</div>
			</div>
		}
	</div>
</div>
